import React, { PureComponent } from 'react';
import { bool, func, number, string } from 'prop-types';
import classNames from 'classnames/bind';
import Icon from 'yoda-core-components/lib/components/Icon';
import ArrowRight from 'yoda-core-components/lib/assets/svg/ArrowRight.svg';
import ArrowLeft from 'yoda-core-components/lib/assets/svg/ArrowLeft.svg';
import YodaDropdown from 'yoda-site-components/lib/components/YodaDropdown/YodaDropdown';
import { getLocaleString } from 'yoda-site-components/lib/components/Pricing/PricingHelper';
import * as styles from './Pagination.css';

const cx = classNames.bind(styles);
class Pagination extends PureComponent {
    static propTypes = {
        hasNextPage: bool.isRequired,
        hasPrevPage: bool.isRequired,
        nextPageOffset: number.isRequired,
        prevPageOffset: number.isRequired,
        productsPerPage: number.isRequired,
        selectedPageNumber: number.isRequired,
        totalPages: number.isRequired,
        totalProductsCount: number.isRequired,
        containerTheme: string,
        marketingTilesInitialCount: number,
        onPageChange: func,
        showDropdown: bool,
    };

    static defaultProps = {
        containerTheme: null,
        marketingTilesInitialCount: 0,
        onPageChange: null,
        showDropdown: null,
    };

    changeHandler(e) {
        const { onPageChange } = this.props;

        onPageChange(Number(e));
    }

    navigatonPagination(targetPage) {
        const { onPageChange, selectedPageNumber } = this.props;

        let gotopage = selectedPageNumber;
        /* istanbul ignore next */
        if (selectedPageNumber > 0) {
            gotopage = selectedPageNumber + targetPage;
        }
        onPageChange(gotopage);
    }

    renderDropdownOptions() {
        const { totalPages, selectedPageNumber } = this.props;
        const options = [];

        if (totalPages > 0) {
            for (let i = 1; i < totalPages + 1; i += 1) {
                options.push({
                    displayKey: `${i}`,
                    value: `${i}`,
                });
            }
        } else {
            options.push({
                displayKey: '1',
                value: 1,
            });
        }

        const dropdownClasses = [
            'bg-white-100',
            'border-1',
            'border-gray-400',
            'border-solid',
            'inline-block',
            'pl-2',
            'relative',
            'rounded-medium',
            'shadow-medium',
            cx('dropdown'),
        ].join(' ');

        const dropDownThemeClasses = ['overflow-y-scroll', cx('dropdown-theme')].join(' ');

        return (
            <YodaDropdown
                automationId="paginationDropdown"
                dataSource={options}
                defaultValue={selectedPageNumber}
                dropdownTheme={dropDownThemeClasses}
                labelTheme={styles.labelTheme}
                mobileTheme={dropdownClasses}
                onChange={(e) => this.changeHandler(e)}
                optionsTheme={styles.optionsTheme}
            />
        );
    }

    render() {
        const {
            containerTheme,
            hasNextPage,
            hasPrevPage,
            marketingTilesInitialCount,
            prevPageOffset,
            productsPerPage,
            showDropdown,
            totalPages,
        } = this.props;

        let { totalProductsCount, nextPageOffset: nextPageOffsetNumber } = this.props;

        if (totalProductsCount < productsPerPage) {
            totalProductsCount += marketingTilesInitialCount;
        }
        if (nextPageOffsetNumber === 0) {
            nextPageOffsetNumber = totalProductsCount;
        }

        const paginationLeftText = ` ${getLocaleString(prevPageOffset)} - ${getLocaleString(nextPageOffsetNumber)} of ${getLocaleString(totalProductsCount)}`; //eslint-disable-line

        const containerClasses = [
            'block',
            'font-open-sans',
            'pb-1 pt-1',
            'relative',
            'text-medium',
            'w-full',
            cx('container', containerTheme),
        ].join(' ');

        const boldTextClasses = ['font-open-sans-bold', 'text-gray-600'].join(' ');

        const paginationSectionClasses = ['inline-block', cx('pagination-section')].join(' ');

        const paginationLeftClasses = ['text-left', cx('pagination-left')].join(' ');

        const paginationRightClasses = ['pb-1', 'text-right', cx('pagination-right')].join(' ');

        const dropDownContainerClasses = [
            'inline-block',
            'pl-4 pr-4',
            cx('dropdown-container'),
        ].join(' ');

        const dropDownMainClasses = ['inline-block', 'pl-1 pr-1', cx('dropdown-main')].join(' ');

        return (
            <div>
                <div className={containerClasses}>
                    <div className={paginationSectionClasses}>
                        <div
                            className={paginationLeftClasses}
                            data-automation-id="pagination-count"
                        >
                            <span className={boldTextClasses}>Showing:</span>
                            {paginationLeftText}
                        </div>
                    </div>
                    <div className={cx('pagination-section', 'pager')}>
                        {showDropdown ? (
                            <div className={paginationRightClasses}>
                                <button
                                    data-automation-id="product-pagination-left"
                                    disabled={!hasPrevPage}
                                    onClick={() => this.navigatonPagination(-1)}
                                    type="button"
                                >
                                    <Icon
                                        className={hasPrevPage ? 'text-gray-600' : 'text-gray-200'}
                                        height="18"
                                        width="18"
                                    >
                                        <ArrowLeft />
                                    </Icon>
                                </button>
                                <div className={dropDownContainerClasses}>
                                    <span className={boldTextClasses}>Page:</span>
                                    <div className={dropDownMainClasses}>
                                        {this.renderDropdownOptions()}
                                    </div>
                                    {`of ${getLocaleString(totalPages)}`}
                                </div>
                                <button
                                    data-automation-id="product-pagination-right"
                                    disabled={!hasNextPage}
                                    onClick={() => this.navigatonPagination(+1)}
                                    type="button"
                                >
                                    <Icon
                                        className={hasNextPage ? 'text-gray-600' : 'text-gray-200'}
                                        height="18"
                                        width="18"
                                    >
                                        <ArrowRight />
                                    </Icon>
                                </button>
                            </div>
                        ) : (
                            <div />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Pagination;
